import * as pdfjsLib from "pdfjs-dist"

pdfjsLib.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.mjs?v=${pdfjsLib.version}`

// Renders every page of the PDF at `url` as a canvas scaled to the container's
// width, appended in order — gives consistent, single-direction vertical
// scrolling on every browser (including iOS Safari, whose native PDF plugin
// inside an iframe does not fit-to-width).
//
// `gap`: when true, wraps each page separately with a shadow + margin (and
// tints the container background) so a gap reads as a clear page break,
// instead of one long white sheet. Off by default to keep existing documents
// looking exactly as before.
export async function renderPdfIntoContainer(container, url, { gap = false } = {}) {
  container.innerHTML = '<p class="text-xl text-font-secondary p-4 text-center">...</p>'

  const pdf = await pdfjsLib.getDocument({ url }).promise
  container.innerHTML = ""
  container.classList.toggle("bg-secondary", gap)

  const outputScale = window.devicePixelRatio || 1

  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    const page = await pdf.getPage(pageNum)
    const containerWidth = container.clientWidth || 600
    const scale = containerWidth / page.getViewport({ scale: 1 }).width
    const cssViewport = page.getViewport({ scale })
    const renderViewport = page.getViewport({ scale: scale * outputScale })

    const canvas = document.createElement("canvas")
    canvas.width = renderViewport.width
    canvas.height = renderViewport.height
    canvas.style.width = `${cssViewport.width}px`
    canvas.style.height = `${cssViewport.height}px`
    canvas.style.display = "block"

    if (gap) {
      const pageWrapper = document.createElement("div")
      pageWrapper.className = pageNum < pdf.numPages ? "shadow-sm mb-3" : "shadow-sm"
      pageWrapper.appendChild(canvas)
      container.appendChild(pageWrapper)
    } else {
      container.appendChild(canvas)
    }

    await page.render({ canvasContext: canvas.getContext("2d"), viewport: renderViewport }).promise
  }
}
